module.exports = __webpack_public_path__ + "img/1341515131.fca99b0a.jpg";